module.exports = __webpack_public_path__ + "img/3.d3f2d03a.png";